import React, { Component } from 'react';
import { connect } from 'react-redux';
import { INTEGRATION, DRAGGABLE_WINDOWS, ASSISTED_TRANSFER, ASSISTED_TRANSFER_SUBACTION,
  API_ENDPOINTS,PREVIEW_TRANSFER,PREVIEW_TRANSFER_SUBACTION } from '../../../constants';
import { phoneIcon, search, phoneIconChange } from '../../../Images/Images';
import { Singleton } from '../../../js/Singleton';
import { arrowBack, btnClear } from '../../../Images/GenericSVG';
import { noAvailableIcon } from '../../../Images/NoAvailableSVG';
import { assistedTransfer } from '../../../Images/CallSpaceHeaderSVG';
import { messageTransferCall , messageAssistedTransferCall , messageApiRequest, actionPreviewTransfer  } from '../../../redux/actions/A_messages_to_SM';
import AssistedTransfer from './AssistedTransfer.jsx'
import CallingAssitedTransfer from './CallingAssistedTransfer.jsx'
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import TableComponent from '../Others/TableComponent'
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller'
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import AlertManualCallWindow from '../../Alerts/AlertManualCallWindow';
import { newAssistedTransferState } from '../../../redux/actions/A_assisted_transfer';
import { alertQueryErrorBody } from '../../../js/alertQueryErrorBody';
import AlertModalActions from '../../../redux/actions/A_Alert_Modal';
import { onAcceptedTransfer, setTransferInProgress} from '../../../redux/actions/A_preview_transfer';
import { bindTransfer, resetAssistedErrorTransfer, resetTransfer } from '../../../redux/actions/A_transfer';

class CallTransfer extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.state = {
      acdList: [],
      phoneList: [],
      agentList: [],
      isManualCallActive: 0,
      phoneNumberTransfer: "",
      searchTransfer: "",
      selectedTransfer: 2,
      position: this.props.position,
      transferring: false,
      agentUnavailable: false,
      onTransferWindow: false,
      onlyAgenda: false,
      recievedAlert: false,
      alertCode: 0,
      dataCall: this.props.objProps.propsData.dataCall,
      isInConference: false,
      transferOption: [{ title: this.language.getText("CallControlGUICallTransferagenda"), index: 0 },
      { title: this.language.getText("CallControlGUICallTransferagents"), index: 1 },
      { title: this.language.getText("CallControlGUICallTransferACD"), index: 2 }],
      itemSelected: null,
      isAgentSelected:false,
      agentSelected:[],
      allowsConference: true,
      messageTransferBlindCall: this.language.getText("CallControlGUICallTransferBlindXferProcess"),
      blindTransferError: false,
    };
    this.data = {
      acdID: 0,
      callKey: "",
      typeTransfer: -1,
      array: "",
      camId: 1,
      sPhone: "",
      dnis: "",
      extId: 0,
      name: "",
      reference: "dial"
    };
    this.phoneNumber = this.props.objProps.propsData.dataCall.Phone;
    this.initialTransferAssisted = [{ title: this.language.getText("CallControlGUIAssistedCallTransfermainCall"), active: false, flag: "main", number: this.phoneNumber, callId: "" },
    { title: this.language.getText("CallControlGUIAssistedCallTransfersecondCall"), active: true, flag: "second", number: "", callId: "" }]
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.sharedData = new SingletonSharedData();
    this.assitedTransPermission = this.sharedData.getGeneralPermissions()[76];
    this.blindTransPermission = this.sharedData.getGeneralPermissions()[250];
    this.AssitedTransferData = this.initialTransferAssisted;
  }

  componentDidMount() {
    let _this = this;
    let objectResponseTransfer = this.apiCont.getObjectResponse();
    let timeout = this.sharedData.getRequestTimeout();
    let userId = this.sharedData.getParameters().UserID;
    let acdId = this.state.dataCall.CallType === 1 ? this.state.dataCall.Id : 0;//filtro para el caso si es una llamda de entrada no puede transferir al mismo acd
    if(this.sharedData.getDataPreviewPro().dialingMode === 1){
      this.props.messageApiRequest(API_ENDPOINTS.TRANSFER_CALL_PREVIEW, "", true);
    }
    else{
      this.apiCont.transferCall(userId, acdId, objectResponseTransfer, timeout);
      objectResponseTransfer.onError = function (messageError) {

      };
      objectResponseTransfer.onCatch = function(messageError){
        console.warn(messageError);
        _this.props.showAlertModal(alertQueryErrorBody());
        _this.cerrarVentana();
      }
      objectResponseTransfer.onSuccess = function (objResponse) {
        _this.setState({
          acdList: objResponse.AcdList,
          phoneList: objResponse.TelefonosList,
          agentList: objResponse.AgentesList,
          isManualCallActive:objResponse.IsManualCallActive,
        });
      };
    }
    switch (this.props.objProps.propsData.messageIntegration.action ) {
      case INTEGRATION.ASSISTED_DIAL_NUMBER:
        this.setState({ selectedTransfer: 0 });
        setTimeout(() => {
          this.integrationAssistedDialNumber(this.props.objProps.propsData.messageIntegration);
        }, 100);
        break;
      case INTEGRATION.ASSISTED_DIAL_AGENT:
        this.setState({ selectedTransfer: 1 });
        setTimeout(() => { this.integrationAssistedDialAgent(this.props.objProps.propsData.messageIntegration); }, 100);
        break;
      case INTEGRATION.ASSISTED_DIAL_ACD:
        setTimeout(() => {
          this.integrationAssistedDialACD(this.props.objProps.propsData.messageIntegration);
        }, 100);
        break;
      default:
        break;
    }
  }
  renderCurrentList() {
    let listTransfer = [{ list: this.state.phoneList, cellName: "cellPhoneTransfer", parameters: { id: "id", name: "name", phone: "number" } },
    { list: this.state.agentList, cellName: "cellAgentTransfer", parameters: { id: "extid", name: "name", login: "login"} },
    { list: this.state.acdList, cellName: "cellACDTransfer", parameters: { id: "inbound_id", name: "name" } }];

    let listDatos = listTransfer[this.state.selectedTransfer];
    let component = <div className="transferListScroll">
      <TableComponent
        customCell={listDatos["cellName"]}
        parameters={listDatos["parameters"]}
        dataSource={listDatos["list"]}
        onSelectItem={this.selectItem.bind(this)}
        searching={this.state.searchTransfer}
        onRef={ref => (this.child = ref)}
        disabled={this.state.phoneNumberTransfer}
        selectedItem={this.state.itemSelected} />
    </div>;
    return component;
  }
  integrationAssistedDialNumber(message) {
    if (!this.state.onTransferWindow) {
      this.setState({ phoneNumberTransfer: message.phone });
      this.assistedTransferCall();
    }
  }

  integrationAssistedDialACD(message){
    if (!this.state.onTransferWindow) {
      let campToTransfer=this.state.acdList.find((camp)=>camp.inbound_id===parseInt(message.id));
      this.selectItem(campToTransfer);
      this.assistedTransferCall();
    }
  }

  integrationAssistedDialAgent(message){
    if (!this.state.onTransferWindow) {
      let agentToTransfer= this.state.agentList.find((agent)=>agent.extid===parseInt(message.id));
      this.selectItem(agentToTransfer)
      this.assistedTransferCall();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.stateMachineActions.actionType === "NO_AVAILABLE_INFO") {
      this.setState({transferring: false});
      this.props.setTransferInProgress(false);
      if(this.props.transferReducer.currentBlindTransfer){
        setTimeout(() => {this.closeAddToast()}, 100);
      }
      else{
        setTimeout(() => {this.closeAssitedToast()}, 100);
      }
    }
    if (nextProps.previewActions.previewAction === PREVIEW_TRANSFER.DATA_CALL_PREVIEW ) {
      this.setState({ phoneList: nextProps.previewActions.phoneList, acdList: nextProps.previewActions.acdList, agentList: nextProps.previewActions.agentList});
    }
    if (nextProps.objProps.propsAlert) {
      this.setState({ recievedAlert: true, alertCode: nextProps.objProps.propsAlert.alertCode });
    }
    if (nextProps.messagesIntegrations.dataMessageIntegration && (nextProps.messagesIntegrations !== this.props.messagesIntegrations)) {
      switch (nextProps.messagesIntegrations.dataMessageIntegration.action) {
        case INTEGRATION.ASSISTED_DIAL_NUMBER:
          this.setState({ selectedTransfer: 0 });
          setTimeout(() => {
            this.integrationAssistedDialNumber(nextProps.messagesIntegrations.dataMessageIntegration);
          }, 100);
          break;
        case INTEGRATION.ASSISTED_DIAL_AGENT:
          this.setState({ selectedTransfer: 1 });
          setTimeout(() => { this.integrationAssistedDialAgent(nextProps.messagesIntegrations.dataMessageIntegration); }, 100);
          break;
        case INTEGRATION.ASSISTED_DIAL_ACD:
          this.setState({ selectedTransfer: 2 });
          setTimeout(() => {
            this.integrationAssistedDialACD(nextProps.messagesIntegrations.dataMessageIntegration);
          }, 100);
          break;
        case INTEGRATION.ASSISTED_TRANSFER_CALL_HANGUP:
          this.hangUpTransfer();
          break;
        default:
          break;
      }
    }
    if(this.props.previewActions.acceptedTransfer !== nextProps.previewActions.acceptedTransfer){
      if(nextProps.previewActions.acceptedTransfer){
        this.data.reference = "dial"
        let _this = this;
        setTimeout(() => {
          _this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.PREVIEW,this.data);
        }, 100);
        setTimeout(() => {
          _this.props.onAcceptedTransfer(null)
        }, 100);
      }
      else{
        this.setState({ transferring: false });
        this.props.onAcceptedTransfer(null)
      }
    }
    switch (nextProps.assistedTransfer.currentState) {
      case ASSISTED_TRANSFER.TRANSFERRING:
        if (this.state.phoneNumberTransfer !== "") {//TRANSFER FOR NUMBER
          this.data.sPhone = this.state.phoneNumberTransfer;
          this.data.typeTransfer = 0;
          this.sharedData.setConferenceNewNumber(this.data.sPhone);
          this.AssitedTransferData[1].number = this.data.sPhone;
        } else {
          switch (this.state.selectedTransfer) {
            case 0:
              this.sharedData.setConferenceNewNumber(this.data.sPhone);
              this.AssitedTransferData[1].number = this.data.sPhone;
              break;
            case 1:
              this.data.sPhone = this.data.extId;
              this.sharedData.setConferenceNewNumber(this.data.name);
              this.AssitedTransferData[1].number = this.data.name;
              break;
            case 2:
              this.data.sPhone = this.data.acdID;
              this.sharedData.setConferenceNewNumber(this.data.name);
              this.AssitedTransferData[1].number = this.data.name;
              break;
            default:
              break;
          }
        }
        this.setState({ transferring: true, phoneNumberTransfer: "" });
        let _this = this;
        if(this.sharedData.getDataPreviewPro().dialingMode === 1 && this.state.isAgentSelected){
          setTimeout(() => { 
          _this.props.actionPreviewTransfer(
              PREVIEW_TRANSFER_SUBACTION.TRANSFER_REQUEST, 
              this.state.agentSelected.login,
              this.props.previewReducer.selectedRecord.callOutId)
          },100);
        } else{
          this.data.reference = "dial"
          setTimeout(() => { _this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data) }, 100);
        }
        break;
      case ASSISTED_TRANSFER.SECOND_CALL_CONNECTED:
        this.setState({ onTransferWindow: true, transferring: false });
        break;
      case ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
        this.setState({ onTransferWindow: false, transferring: false, isInConference: false });
        this.AssitedTransferData = this.initialTransferAssisted;
        this.sharedData.setCallConferencetoZero();
        break;
      case ASSISTED_TRANSFER.ON_CONFERENCE:
        this.setState({ isInConference: true });
        break;
      case ASSISTED_TRANSFER.ON_CONFERENCE_CALL:
        this.returnToConference();
        break;
      default:
        break;
    }
  }

  callNewNumber() {
    this.props.newAssistedTransferState(ASSISTED_TRANSFER.ON_CONFERENCE_CALL);
    this.sharedData.setConferenceNewNumber(this.data.sPhone);
    this.data.reference = "next";
    this.data.callId = Math.floor((Math.random() * 10000));
    this.sharedData.setConferenceCallID(this.data.callId);
    let _this = this;
    setTimeout(() => { _this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data) }, 100);
  }

  closeAlert(e) {
    this.setState({ recievedAlert: e });
  }

  selectItem(item) {
    this.setDatos(item);
    this.setState({ itemSelected: item });
    if(this.state.selectedTransfer === 1){
      const agent = this.props.previewActions.agentList.find(agent => agent.extid == item.extid);
      this.setState({ isAgentSelected: true, agentSelected: agent });
    }
  }

  selectTransfer(transfer) {
    this.setState({
      itemSelected: null,
      selectedTransfer: transfer,
      searchTransfer: ""
    });
  }

  hangUpTransfer() {
    if(this.state.transferring) this.setState({ transferring: false});
    this.data.reference = "hangup"
    setTimeout(() => {
      this.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,this.data);
    }, 50);
    this.props.setTransferInProgress(false);
  }

  closeAgentUnavailable() {
    this.setState({ agentUnavailable: false });
  }

  openAgenda() {
    this.setState({
      onTransferWindow: false,
      onlyAgenda: true,
      selectedTransfer: 0,
    });
  }

  returnToConference() {
    this.setState({
      onTransferWindow: true,
      onlyAgenda: false,
      selectedTransfer: 2,
    });
  }

  setDatos(item) {
    switch (this.state.selectedTransfer) {
      case 0:
        this.data.acdID = this.state.dataCall.Id;
        this.data.typeTransfer = this.state.selectedTransfer;
        this.data.sPhone = item.number;
        this.data.callKey = this.state.dataCall.CalKey;
        this.data.name = item.name.split("|")[1].trim();
        this.setState({ allowsConference: item.allowsConference });
        break;
      case 1:
        this.data.acdID = this.state.dataCall.Id;
        this.data.camId = this.state.dataCall.Id;
        this.data.typeTransfer = this.state.selectedTransfer;
        this.data.callKey = this.state.dataCall.CalKey;
        this.data.sPhone = this.state.dataCall.Phone;
        this.data.dnis = this.state.dataCall.DNIS;
        this.data.extId = item.extid;
        this.data.name = item.name.split(" ")[0];
        this.setState({ allowsConference: true });
        break;
      case 2:
        this.data.acdID = item.inbound_id;
        this.data.typeTransfer = this.state.selectedTransfer;
        this.data.callKey = this.state.dataCall.CalKey;
        this.data.sPhone = this.state.dataCall.Phone;
        this.data.name = item.name.split(" ")[0];
        this.setState({ allowsConference: true });
        break;
      default: break;
    }
    this.setState({ itemSelected: item.key });
  }
  cancelBlindTransfer() {
    this.setState({ 
      messageTransferBlindCall: this.language.getText("CallControlGUICallTransferBlindXferError"),
      blindTransferError: true
    });
  }
  
  closeAddToast(e) {
    this.setState({ 
      messageTransferBlindCall: this.language.getText("CallControlGUICallTransferBlindXferProcess"),
      blindTransferError: false,

    });
    this.props.resetTransfer(); 

  }

  closeAssitedToast(e) {
    this.props.resetAssistedErrorTransfer();
  }

  transferCall() {

    this.props.bindTransfer(true)

    if (this.state.phoneNumberTransfer === "") {//TRANSFER FOR SELECTION
      this.props.messageTransferCall(this.data);
    } else {//TRANSFER FOR PHONE NUMBER
      this.data.acdID = this.state.dataCall.Id;
      this.data.typeTransfer = 0;
      this.data.callKey = "";
      this.data.sPhone = this.state.phoneNumberTransfer;
      this.props.messageTransferCall(this.data);
    }
  }
  assistedTransferCall() {
    setTimeout(() => {
      this.props.newAssistedTransferState(ASSISTED_TRANSFER.TRANSFERRING);
    }, 50);
    if(this.props.previewReducer.simultaneosRecs)
    {
      this.props.setTransferInProgress(true);
    }
  }
  cerrarVentana() {
    this.props.removeWindow(DRAGGABLE_WINDOWS.TRANSFER_CALL);
  }
  componentWillUnmount() {
    this.props.resetTransfer();
  }
  render() {
    var transferOption = this.state.transferOption;
    if (this.state.onlyAgenda) {
      transferOption = transferOption.filter(item => { return item.index === 0 })
    }
    return (
      <div className="transferContainer" onClick={() => this.props.goTopZ(this.props.id)}>
        {CUSTOM_COMPONENTS["draggableHeader"](assistedTransfer,
          this.language.getText("CallControlGUICallTransfertitle"),
          (!(this.state.isInConference || this.state.onTransferWindow || this.state.transferring) && this.cerrarVentana.bind(this)))}
        {this.state.onTransferWindow ?
          <AssistedTransfer
            data={this.AssitedTransferData}
            onOpenAgenda={() => this.openAgenda()}
            isInConference={this.state.isInConference}
            allowsConference={this.state.allowsConference} 
            previewTransfer={this.state.agentSelected} /> :
          <div className="transferOptionsContainer">
            <div className="blurContainer">
              <div className={"transferSelectionContainer " + (this.state.transferring || this.state.recievedAlert ? "active" : "")}>
                <div className="transferSelection">
                  {(transferOption.map((item, i) =>
                    <div className={"transferOptions"} key={"item" + i} onClick={() => this.selectTransfer(item.index)} >
                      <div className={"backOption " + (this.state.selectedTransfer === item.index ? "selectedOption" : "nonSeletedOption")}></div>
                      <p className="transferTitle">{item.title}</p>
                    </div>))}
                  <div className={"backArrowAgenda " + (this.state.onlyAgenda ? "" : "hidden")} onClick={() => this.returnToConference()}> {arrowBack} </div>
                  <div className={"selectionFooter selected_" + this.state.selectedTransfer}></div>
                </div>
                <div className={"transferList " + (this.state.onlyAgenda && " onlyAgenda")}>
                  {CUSTOM_COMPONENTS["inputDelete"](this.state.searchTransfer, (e) => { this.setState({ searchTransfer: e }) },
                    "searchBarTransfer", "txtSearch", "buttonclearGray", btnClear, false, search, "iconSearch", this.language.getText("CallControlCRMxcontrolssearchForMatchesButton"))}
                  {this.renderCurrentList()}
                </div>
                {this.state.onlyAgenda ?
                  <div className="transferFooterOnlyAgenda" onClick={() => this.callNewNumber()}>
                    <img className="optionTransfer greenColor" src={phoneIconChange} alt="icon"></img>
                  </div>
                  : <div className="transferFooter">
                    {CUSTOM_COMPONENTS["inputDelete"](this.state.phoneNumberTransfer, (e) => { this.setState({ phoneNumberTransfer: e, allowsConference: true });},
                      "phoneNumberTransfer" + (this.state.phoneNumberTransfer && " campActive"), "txtPhoneNumber", "buttonClearWhite", btnClear, true,
                      phoneIcon, "iconPhoneNumber" + (this.state.phoneNumberTransfer && " campActive"),
                      this.language.getText("CallControlGUIAssistedCallTransferenterNumber"),!this.state.isManualCallActive
                    )}
                    {this.sharedData.getDataPreviewPro().dialingMode !== 1 && 
                      <div className={"transferButton " + (this.blindTransPermission === "1" ? (!this.state.phoneNumberTransfer && !this.state.itemSelected) ? "disabled" : "" : "disabled") + " " + ((this.state.phoneNumberTransfer || this.state.selectedTransfer === 0) && "small")}
                      onClick={() => this.transferCall()}>
                        {this.language.getText("CallControlGUIAssistedCallTransferblindtransfer")}
                        </div>
                    }
                    <div
                      className={"transferButton2 " + 
                      (this.assitedTransPermission === "1" ? (
                        this.state.phoneNumberTransfer ? "" : (!this.state.itemSelected ? "disabled" : 
                        (this.state.selectedTransfer === 2 && this.state.itemSelected.inbound_id < 0 ? "disabled" : ""))) 
                        : "disabled")}
                      onClick={() => this.assistedTransferCall()}>
                        {this.language.getText("CallControlGUIAssistedCallTransfertitle")}
                    </div>
                  </div>
                }
              </div>
              {this.state.recievedAlert &&
                <AlertManualCallWindow
                  phoneNumber={this.phoneNumber}
                  alertCode={this.state.alertCode}
                  closeAlert={(e) => this.closeAlert(e)}
                />
              }
              {this.props.transferReducer.currentAssistedTransfer &&
                <AlertManualCallWindow
                  className={`alertBlindTransfer alertBlindTransferError`}
                  icon
                  buttonClose
                  message={this.language.getText("CallControlGUICallTransferno-answer-error")}
                  alertCode={'CUSTOM'}
                  closeAlert={(e) =>{this.closeAssitedToast(e) }}
                />
              }
              {this.props.transferReducer.currentBlindTransfer &&
                <AlertManualCallWindow
                  className={`alertBlindTransfer ${this.state.blindTransferError && 'alertBlindTransferError' }`}
                  icon={this.state.blindTransferError}
                  buttonClose={this.state.blindTransferError}
                  message={this.state.messageTransferBlindCall}
                  alertCode={'CUSTOM'}
                  closeAlert={(e) =>{this.closeAddToast(e) }}
                />
              }
            </div>
            {this.state.transferring &&
              <CallingAssitedTransfer
                phoneNumberTransfer={this.sharedData.getConferenceNewNumber()}
                hangUpTransfer={() => this.hangUpTransfer()}
              />
            }
            {this.state.agentUnavailable &&
              <div className="agentUnavailableWindowContainer">
                <div className="agentUnavailableWindow">
                  <p className="agentUnavailableName">{this.data.name}</p>
                  <div className="agentUnavailableInfoContainer">
                    <div className="iconAgentUnavailable">
                      {noAvailableIcon}
                    </div>
                    <p className="agentUnavailableText">{this.language.getText("GUIDisableModetitle")}</p>
                  </div>
                  <div className="closeAgentUnavailable" onClick={() => this.closeAgentUnavailable()}>{this.language.getText("CallControlGUIAssistedCallTransferaccept")}</div>
                </div>
                <div className="transferringWindowBottom"></div>
              </div>}
          </div>}
        </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    stateMachineActions: state.stateMachineActions,
    assistedTransfer: state.assistedTransfer,
    messagesIntegrations: state.messagesIntegrations,
    previewActions: state.previewActions,
    transferReducer: state.transferReducer,
    previewReducer: state.preview
  }
}

function mapDispatchToProps(dispatch) {
  const { showAlertModal} = AlertModalActions.creators;
  return {
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    messageTransferCall: (data) => { dispatch(messageTransferCall(data)); },
    messageAssistedTransferCall: (action, data) => { dispatch(messageAssistedTransferCall(action, data)); },
    newAssistedTransferState: (message) => { dispatch(newAssistedTransferState(message)); },
    messageApiRequest: (subaction, json, expectsReponse) => { dispatch(messageApiRequest(subaction, json, expectsReponse)); },
    actionPreviewTransfer: (subaction, agentLogin, callOutId) => { dispatch(actionPreviewTransfer(subaction,agentLogin,callOutId)); },
    onAcceptedTransfer: (value) => { dispatch(onAcceptedTransfer(value)); },
    showAlertModal: payload => {
      dispatch(showAlertModal(payload));
    },
    bindTransfer: (payload)=>{dispatch(bindTransfer(payload))},
    resetTransfer: (payload)=>{dispatch(resetTransfer(payload))},
    resetAssistedErrorTransfer: ()=>{dispatch(resetAssistedErrorTransfer())},
    setTransferInProgress: (flag) => {dispatch(setTransferInProgress(flag))}
  }
}

export default CallTransfer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CallTransfer);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/CallTransfer.jsx